<script lang="ts">
    let {
        IsOpen = $bindable(false),
        onClose = () => {},
    } = $props();


    let close = () => {
        onClose();
    };
</script>

<div class="flex flex-col">
    <h2>Geen toegang</h2>

    <p>Om volledige toegang te krijgen tot deze collectie is het NVBS-lidmaatschap nodig.</p>

    <p>Ben je al lid, <a href="/mijn-nvbs">klik dan hier om in te loggen.</a></p>

    <p>Ben je nog geen NVBS-lid? <a href="/lidmaatschap/">Klik hier voor informatie</a> over het lidmaatschap.</p>

    <p>Wil je nadere inlichtingen over gebruik van afbeeldingen in publicaties of websites, neem dan contact op met <a
            href="mailto:fotobureau@nvbs.com">fotobureau@nvbs.com</a>.</p>

    <button
            class="btn btn-primary"
            onclick={close}
    >
        Terug
    </button>

</div>

<style lang="scss">
  button {
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
    }
  }
</style>